export default "__VITE_ASSET__mZ0BN2Z9__"